import Vue from 'vue'
import {mapActions} from 'vuex'
import * as config from './config.js'

Vue.mixin({
  methods: {
    handleLogout (redirect = true) {
      this.unsetUser()
      if (redirect) this.$router.push({name: 'home'})
    },
    redirectWithCompanyId (route) {
      if (route.query.redirect) {
        let redirect = route.query.redirect
        if (redirect && redirect.indexOf('?') >= 0) {
          let search = redirect.substring(redirect.indexOf('?') + 1)
          let query = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
          if (query.company_id) return true
        }
      }
      return false
    },
    hasHeader (route) {
      if (this.redirectWithCompanyId(route)) return false
      if (route.query.company_id) return false
      const exclude = ['rent_sent', 'company_checkout']
      return !exclude.includes(route.name)
    },
    hasFooter (route) {
      if (this.redirectWithCompanyId(route)) return false
      if (route.query.company_id) return false
      const exclude = ['rent_sent', 'company_checkout']
      return !exclude.includes(route.name)
    },
    getCatalogRouteParams (params) {
      if (this.companyId) {
        params.query = {
          company_id: this.companyId
        }
      }
      return params
    },
    imageUrl (path, resize = false) {
      let extension = path.substring(path.lastIndexOf('.') + 1)
      let fileName = path.substring(0, path.lastIndexOf('.'))
      let template = 'original'
      if (resize) {
        fileName += '-resize(' + resize + ')'
        template = 'resize'
      }
      let url = fileName + '.' + extension
      return config.cdnURL + 'image/' + template + '/' + url
    },
    isMobile (clientWidth) {
      return (clientWidth < 992)
    },
    goToScroll (target, duration = 500) {
      if (isNaN(target)) {
        this.$SmoothScroll(window.$(target, this.$el).get(0), duration)
      } else {
        this.$SmoothScroll(target, duration)
      }
    },
    phoneNumber: str => {
      if (!str || str === '') return ''
      str = str.replace('_', '')
      if (str.length === 13) {
        let num = str.charAt(8)
        str = str.replace(num + '-', '-' + num)
      }
      return str
    },
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
    time: (value, full = true) => {
      if (!value || value === '') return '-'
      if (full) {
        return window.moment(value, 'DD/MM/YY à\\s H\\hm').calendar(null, {
          sameDay: '[Hoje] [às] H:mm',
          nextDay: '[Amanhã] [às] H:mm',
          nextWeek: 'DD/MM/YY [às] H:mm',
          lastDay: '[Ontem] [às] H:mm',
          lastWeek: 'DD/MM/YY [às] H:mm',
          sameElse: 'DD/MM/YY [às] H:mm'
        })
      } else {
        return window.moment(value, 'DD/MM/YYYY').calendar(null, {
          sameDay: '[Hoje]',
          nextDay: '[Amanhã]',
          nextWeek: 'DD/MM/YY',
          lastDay: '[Ontem]',
          lastWeek: 'DD/MM/YY',
          sameElse: 'DD/MM/YY'
        })
      }
    },
    money: (value) => {
      if (isNaN(value) || parseFloat(value) < 1) return '- -'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
      }).format(value)
    },
    rentType: (value) => {
      let types = [null, 'Diária', 'Semanal', 'Quinzenal', 'Mensal']
      return types[value]
    },
    periodName: (value) => {
      let types = [null, 'Manhã', 'Tarde']
      return types[value]
    },
    rentPeriod (type) {
      return [null, 'dia', 'semana', 'quinzena', 'mês'][type]
    },
    rentPeriods (periods, type) {
      if (periods === 1) {
        return [null, 'dia', 'semana', 'quinzena', 'mês'][type]
      } else if (periods > 1) {
        return [null, 'dias', 'semanas', 'quinzenas', 'mêses'][type]
      }
      return ''
    },
    paymentMethod: (value) => {
      let text = ''
      switch (value) {
        case 'cash':
          text = 'Dinheiro'
          break
        case 'boleto':
          text = 'Boleto'
          break
        case 'credit_card':
          text = 'Cartão de Crédito'
          break
        default:
          text = '- -'
      }
      return text
    },
    slugify (text) {
      text = text.toString().toLowerCase().trim()
      const sets = [
        {to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶ]'},
        {to: 'c', from: '[ÇĆĈČ]'},
        {to: 'd', from: '[ÐĎĐÞ]'},
        {to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]'},
        {to: 'g', from: '[ĜĞĢǴ]'},
        {to: 'h', from: '[ĤḦ]'},
        {to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]'},
        {to: 'j', from: '[Ĵ]'},
        {to: 'ij', from: '[Ĳ]'},
        {to: 'k', from: '[Ķ]'},
        {to: 'l', from: '[ĹĻĽŁ]'},
        {to: 'm', from: '[Ḿ]'},
        {to: 'n', from: '[ÑŃŅŇ]'},
        {to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]'},
        {to: 'oe', from: '[Œ]'},
        {to: 'p', from: '[ṕ]'},
        {to: 'r', from: '[ŔŖŘ]'},
        {to: 's', from: '[ßŚŜŞŠ]'},
        {to: 't', from: '[ŢŤ]'},
        {to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]'},
        {to: 'w', from: '[ẂŴẀẄ]'},
        {to: 'x', from: '[ẍ]'},
        {to: 'y', from: '[ÝŶŸỲỴỶỸ]'},
        {to: 'z', from: '[ŹŻŽ]'},
        {to: '-', from: '[·/_,:;\']'}
      ]

      sets.forEach(set => {
        text = text.replace(new RegExp(set.from, 'gi'), set.to)
      })

      return text
      .replace(/\s+/g, '-')    // Replace spaces with -
      .replace(/[^\w-]+/g, '') // Remove all non-word chars
      .replace(/--+/g, '-')    // Replace multiple - with single -
      .replace(/^-+/, '')      // Trim - from start of text
      .replace(/-+$/, '')      // Trim - from end of text
    },
    ...mapActions(['unsetUser'])
  }
})



// WEBPACK FOOTER //
// ./src/mixin.js